import { ReactNode } from "react"
import { TooltipContent, TooltipCustom, TooltipTrigger } from "@/components/ui/tooltip"

export const WithTooltip = (props: { children: ReactNode; text: string }) => {
  return (
    <TooltipCustom>
      <TooltipTrigger asChild>{props.children}</TooltipTrigger>
      <TooltipContent>{props.text}</TooltipContent>
    </TooltipCustom>
  )
}
